import {
	getColor,
	getGradient,
	getSize,
	getWeight,
} from "views/resources/theme";
import logo from "../../../resources/logos/logo_white.png";
import styled from "styled-components";

export const Logo = styled.img.attrs({
	src: logo,
})`
	width: 184px;
	height: 56px;
	margin: ${({ margin = 68 }) => `${margin}px auto;`};
`;

export const Wrapper = styled.div`
	background: ${getGradient("default")};
	height: 100vh;
	display: flex;
	flex-direction: column;
	padding: ${getSize("xxl")} ${getSize("m")};

	h2 {
		color: ${getColor("fg_alt")};
		margin: 0;
		font-weight: ${getWeight("regular")};
		text-align: center;
	}

	.pass {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.password__success-label {
		font-weight: 700;
	}
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 24px;
	text-align: center;
	color: #fff;
	margin-bottom: 31px;
`;

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	color: ${getColor("fg_alt")};
	margin: ${getSize("l")} ${getSize("m")};
`;

export const Label = styled.label`
	display: block;
	font-size: 0.875rem;
	font-size: ${(props) =>
		props.small ? props.theme.size["sm"] : props.theme.size["m"]};

	@media screen and (min-width: 768px) {
		& {
			font-size: 12px;
			font-weight: 500;
			line-height: 16px;
			color: #a3a3a3;
		}
	}
`;

export const Input = styled.input`
	display: block;
	background: transparent;
	color: ${getColor("fg_alt")};
	border: none;
	border-bottom: 1px solid ${getColor("fg_alt")};
	font-size: ${(props) => props.theme.size["m"]};
	margin: ${getSize("m")} 0;

	&:-webkit-autofill,
	&:-webkit-autofill:hover,
	&:-webkit-autofill:focus {
		-webkit-text-fill-color: #fff !important;
		-webkit-box-shadow: 0 0 0px 0 0 0px 1000px #394ba4 inset !important;
		transition: background-color 5000s ease-in-out 0s;
	}

	@media screen and (min-width: 768px) {
		& {
			font-size: 12px;
			font-weight: 500;
			line-height: 16px;
			color: #000;
			width: 100%;
		}
	}
`;

export const FormFieldGroup = styled.div`
	label,
	input {
		display: block;
	}
	label {
		color: #282828;
		font-size: 16px;
		margin-bottom: 16px;
	}
	input[type="text"] {
		font-size: 14px;
		font-weight: 500;
		line-height: 16px;
		background: transparent;
		color: ${getColor("fg_alt")};
		color: #145ab4;
		border: none;
		border-bottom: 1px solid ${getColor("fg_alt")};
		border-bottom: 1px solid #a0a0a0;
		margin: ${getSize("m")} 0;
		margin-bottom: 31px;
		width: 100%;
	}
	span.error {
		font-size: ${getSize("sm")};
		color: red;
		font-weight: 600;
	}
`;

export const Error = styled.p`
	color: ${getColor("error")};
	color: #ffcccb;
	background-color: transparent;
`;
